import React, { Component, PropTypes } from 'react'

import CopyUrl from './copy-to-clipboard'

class CopyUrlContainer extends Component {

  constructor(props) {
    super(props)

    this.state = {
      copied: false,
    }

    this.handleCopy = this.handleCopy.bind(this)
    this.resetCopyState = this.resetCopyState.bind(this)
  }

  resetCopyState() {
    this.setState({ copied: false })
  }

  handleCopy() {
    this.setState({ copied: true }, () => {
      setTimeout(this.resetCopyState, 1000)
    })
  }

  render() {
    return (
      <CopyUrl
        {...this.props}
        copied={this.state.copied}
        onCopy={this.handleCopy}
      />
    )
  }

}

CopyUrlContainer.propTypes = {
  link: PropTypes.string,
  snippet: PropTypes.string,
}

export default CopyUrlContainer



/** WEBPACK FOOTER **
 ** ./src/components/copy-to-clipboard/copy-to-clipboard-container.js
 **/